module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "race-question"
  }, [_c('modal', {
    attrs: {
      "name": "bonusDistance"
    },
    on: {
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add Bonus Distance")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bonusdistance),
      expression: "bonusdistance"
    }],
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "number",
      "id": "newdistance",
      "maxlength": "255",
      "name": "newdistance",
      "Placeholder": ""
    },
    domProps: {
      "value": (_vm.bonusdistance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bonusdistance = $event.target.value
      }
    }
  }), _vm._v(" Km\n      "), _c('div', [(_vm.error) ? _c('div', {
    staticClass: "error-msg"
  }, [_c('span', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errorMsg))])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "save-distance"
    },
    on: {
      "click": function($event) {
        _vm.Save(_vm.bonusdistance)
      }
    }
  }, [_vm._v("Save")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4197786d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/BonusDistanceModal.vue
// module id = 1668
// module chunks = 1